export function formatText(text, length) {
  if (!text) return;
  if (text.length > length) {
    let subtractString = text.substring(0, length);
    return subtractString + '...';
  } else if (text.length <= length) {
    return text;
  }
}
export function formatTextStar(text, length) {
  if (!text) return;
  if (text.length > length) {
    let subtractString = text.substring(0, length);
    return subtractString + '***';
  } else if (text.length <= length) {
    return text;
  }
}
